// @flow
/* eslint-disable sort-keys, max-len */
export default {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'Inicie sesión para pujar',
                signup: 'Regístrese para pujar',
                register_long: 'Registrarse para la subasta',
                pending: 'Registro pendiente',
                declined: 'Registro rechazado',
                closed: 'Lote cerrado',
                sent: 'Su oferta ha sido enviada',
                outbid: 'Has sido superado, Ofrece {amount}',
                bid: 'Ofrece {amount}',
                winning: 'Estás ganando',
            },
            conversions: {
                lot_number: 'Lote {lotNumber}',
            },
            description: {
                estimate_range: 'Es. {low} - {high}',
                images_label: '{currentImageNumber} / {totalImages}',
            },
            messages: {
                competing_bid_amount: '{amount}: Oferta competidora',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    'El licitador competidor fue superado por la oferta ausente del licitador {paddleNumber}',
                last_bid_retracted: 'Última oferta de {amount} fue retractada',
                liveauctioneers_bid_amount: '{amount}: Licitador de LiveAuctioneers {paddleNumber}',
                liveauctioneers_bid_amount_absentee:
                    '{amount}: Oferta en Vivo del Licitador {paddleNumber} de LiveAuctioneers',
                lot_number_passed: 'Lote {lotNumber} pasado',
                lot_number_reopened: 'Lote {lotNumber} reabierto',
                lot_number_skipped: 'Lote {lotNumber} omitido',
                lot_number_unsold: 'Lote {lotNumber} sin vender',
                lot_opened_asking: 'Lote {lotNumber} abierto - ofrece {amount}',
                lot_sold_competing_bidder: 'Lote {lotNumber} se vendió por {amount} al Licitador Competidor',
                lot_sold_liveauctioneers_bidder: 'Lote {lotNumber} se vendió por {amount} al Licitador {paddleNumber}',
                my_bid_amount: '{amount}: Mi oferta',
                my_bid_amount_absentee: '{amount}: Mi oferta ausente',
                my_bid_retracted: 'Su oferta por {amount} fue retractada',
                registration_approved: 'Su registro ha sido aprobado',
                reserve_not_met: 'Reserva no encontrada',
                you_been_outbid_by_liveauctioneers_absentee:
                    'Has sido superado por la oferta ausente del Licitador {paddleNumber}',
                you_ve_won_lot: 'Has ganado el lote {lotNumber}',
            },
            missives: {
                fair_warning_lot_about_to_close: 'Advertencia... Este lote está por cerrar',
                going_once_going_twice: 'Se va a la una... Se va a las dos',
                third_and_final_warning: 'Tercera y final advertencia...',
            },
            status: {
                remaining: '{remaining} de {total} lotes restantes',
            },
            thumbnail_scroller: {
                next: 'Siguientes lotes',
            },
        },
    },
};
